import { registerSurfaceItem } from "@/lib/surfaces";
import { lazyNamed } from "@/lib/lazyNamed";

/** US-010 — incidents domain dashboard contribution. */
registerSurfaceItem("dashboard-stats", {
  id: "open-incidents",
  order: 40,
  Component: lazyNamed(
    () => import("./OpenIncidentsStatCard"),
    "OpenIncidentsStatCard",
  ),
});
